import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SubscriptionModel from "../models/subscription/SubscriptionModel";
import { isDateInsideRange, today } from "../utilities/dateTimeUtils";
import { DATE_NUMBER_FORMAT } from "../constants/TIME";
import * as SubscriptionAction from "../stores/subscriptions/SubscriptionAction";

export interface IIsUserSubscribed {
    isSubscribed: boolean;
    isVisible: boolean;
}

export const useIsUserSubscribed = (userId, sId): IIsUserSubscribed => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (userId) {
            dispatch(SubscriptionAction.requestUserSubscriptions(userId));
        }
    }, [dispatch, userId]);
    
    const userSubscriptionsFromState = useSelector(state => state.subscriptions?.userSubscriptions);
    let singleIsinSubscription;
    if (userSubscriptionsFromState) {
        singleIsinSubscription = Object.values(userSubscriptionsFromState)?.find(
            (subscription: SubscriptionModel) => subscription.typeId === sId
        );
        const isSubscribed = singleIsinSubscription?.dateRanges?.ranges?.some(range => {
            return isDateInsideRange(
                parseInt(today().format(DATE_NUMBER_FORMAT)),
                range?.startDate,
                range?.endDate
            );
        });

        const isVisible = singleIsinSubscription?.dateRanges?.ranges?.some(range => range.isVisible);

        return {
            isSubscribed,
            isVisible
        };
    }
};